import "./toggle.css";
import QuestionMark from "../svgs/questionMark";
export const Toggle = ({
  id,
  isChecked,
  label,
  handleCheckboxChange,
  onClickQuestionMark,
}: any) => {
  const _id = "radio-" + id.toString();

  return (
    <div className="container-toggle">
      <div className="label-checkbox">{label}</div>
      <div className="container-checkbox">
        <input
          type="checkbox"
          className="checkbox"
          id={_id}
          checked={isChecked}
          onChange={handleCheckboxChange}
        />
        <label className="switch" htmlFor={_id}>
          <span className="slider"></span>
        </label>
      </div>
      <QuestionMark onClick={onClickQuestionMark} />
    </div>
  );
};
